import React from 'react';
import { useLocation } from 'react-router-dom';

import ActionButton from '../../elements/ActionButton';
import ProtectedLink from '../../elements/ProtectedLink';
import ColoredStatus from '../../elements/common/ColoredStatus';
import TableDataValue from '../../elements/tableDataValue';

import GetDepositResponse from 'Api/CRM/Responses/DepositResponse';
import SortButton, { SortProps } from 'crm/elements/common/SortButton';
import { TableCell as Cell } from 'crm/elements/common/TableDetailsRow';
import TableHead from 'crm/elements/common/TableHead';
import { PERMISSION } from 'crm/helpers/Permissions';
import { formatDateStringWithTimezone } from 'utils/formatters';

type Props = Readonly<{ deposits: GetDepositResponse[]; sortProps: SortProps }>;

function DepositsTableDefault({ deposits, sortProps }: Props) {
    const location = useLocation();
    const isUserDetails = location.pathname.includes('users');

    const depositsList = deposits.map((deposit) => (
        <tr key={deposit.id}>
            <td>
                <ActionButton title="open" url={`/deposits/${deposit.id}`} permissions={[PERMISSION.VIEW_DEPOSIT]} />
            </td>
            <Cell>{deposit.token}</Cell>
            {!isUserDetails && [
                <td key="email">
                    <ProtectedLink
                        url={`/users/${deposit.user_id}`}
                        value={deposit.email}
                        permissions={[PERMISSION.VIEW_USER]}
                    />
                </td>,
                <td key="phone">
                    <TableDataValue value={deposit.phone} />
                </td>,
            ]}
            <Cell>{deposit.payment_method_name}</Cell>
            <Cell>{deposit.amount_formatted}</Cell>
            <Cell>{deposit.user_fee_formatted}</Cell>
            <Cell>
                <ColoredStatus status={deposit.status} colorset="deposits" />
            </Cell>
            <Cell>{formatDateStringWithTimezone(deposit.date_confirmed)}</Cell>
            <Cell>{formatDateStringWithTimezone(deposit.created_at)}</Cell>
        </tr>
    ));

    return (
        <table className="table model-list">
            <TableHead>
                <th>Action</th>
                <SortButton column="token" {...sortProps} />
                {!isUserDetails && [
                    <SortButton key="email" column="users.email" label="E-mail" {...sortProps} />,
                    <SortButton key="phone" column="users.phone" label="Phone" {...sortProps} />,
                ]}
                <SortButton column="payment_method_id" label="Payment method" {...sortProps} />
                <SortButton column="amount" {...sortProps} />
                <SortButton column="user_fee" label="Payment cost" {...sortProps} />
                <SortButton column="status" {...sortProps} />
                <SortButton column="date_confirmed" {...sortProps} />
                <SortButton column="created_at" order="desc" {...sortProps} />
            </TableHead>
            <tbody>{depositsList}</tbody>
        </table>
    );
}

export default DepositsTableDefault;
